import { gql } from 'apollo-boost';

export const UPDATE_PLAN = gql`
    mutation UpdatePlan($data: UpdatePlanInput!) {
        updatePlan(data: $data) {
            id
            name
            description
            benefits { id kind translationKey fallback value valueSource }
        benefitListId
        benefitList { id name en de revision translations { language lines } }
            type
            planType
            accessKind
            accessPriority
            price
            anchorPrice
            currency
            active
            maxMessages
            maxStorage
            maxFileSize
            maxCredits
            featureLimits {
                webviewSettings
                slackConnections
                imports {
                    maxFetchPerSource
                    maxSelectedPerImport
                    maxAutoImportPerRun
                    fullHistorySyncEnabled
                }
            }
            index
            ios
            android
            landing
            web
            landingDescription
            appearance
            showUpgradeOffers
            tag
            promoCode
            stripePriceId
            stripeProductId
            stripePaymentLink
            stripeTrialDays
            stripeIntroPriceId
            revenueCatApiId
            revenueCatProductId
            descriptionRevenueCatAndroid
            descriptionRevenueCatIos
            limitedOffer {
                text
                endDate
                isActive
            }
        }
    }
`;
